import React from 'react'
import { Edit, SimpleForm, TextInput } from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import SectionTitle from '../components/SectionTitle'

const styles = {
  textInput: { width: 500 },
}

const useStyles = makeStyles(styles)

const TagTypeEdit = (props) => {
  const classes = useStyles()
  return (
    <Edit {...props}>
      <SimpleForm>
        <SectionTitle label="Edit Tag Type" />
        <TextInput source="name" formClassName={classes.textInput} fullWidth required />
        <TextInput source="description" formClassName={classes.textInput} fullWidth multiline rows={3} />
        <TextInput
          source="color"
          formClassName={classes.textInput}
          fullWidth
          helperText="Hex color code (e.g., #FF5733)"
          placeholder="#FF5733"
        />
      </SimpleForm>
    </Edit>
  )
}

export default TagTypeEdit

